// services
import Fetch from 'modules/Fetch';
import FormatService from 'modules/Format';
import Logger from 'modules/Logger';
// typings
import { SegmentType } from 'modules/Search/constants';
import {
  GetMarketHolidayDateResponse,
  TvChartMarketHolidays,
  TvChartCorrectionsFromMarketHolidays,
} from './typings';

class MarketHolidayDates {
  private tvChartMarketHolidayDates = {} as TvChartMarketHolidays;
  private correctionsFromHolidaysForTvCharts = {
  } as TvChartCorrectionsFromMarketHolidays;

  // init data fetching
  init = async () => {
    await this.getMarketHolidayDates();
  };

  getMarketHolidayDatesForTvCharts = (segment: SegmentType) =>
    this.tvChartMarketHolidayDates[segment] || [];

  getCorrectionsFromHolidaysForTvCharts = (segment: SegmentType) =>
    this.correctionsFromHolidaysForTvCharts[segment] || [];

  async getMarketHolidayDates(): Promise<void> {
    try {
      const response: HttpResponse<GetMarketHolidayDateResponse> =
        await Fetch.request(
          'MARKET_HOLIDAYS',
          '',
          'MARKET_HOLIDAYS',
        );

      if (response.success && response.data) {
        const marketHolidayDates = FormatService.formatMarketHolidayDates(
          response?.data?.holidays || [],
        );

        this.tvChartMarketHolidayDates = marketHolidayDates.tvChart;
        this.correctionsFromHolidaysForTvCharts =
          marketHolidayDates.tvChartCorrections;
      }
    } catch (error) {
      Logger.error(error);
    }
  }
}

export default new MarketHolidayDates();
